const { Config } = require('@shopstory/core');
const { contentfulPlugin } = require('@shopstory/core/contentful');

const {
  contentful_access_token,
  contentful_space,
  fetchContentfulEntry,
  getContentfulItemById,
  getContentfulItems,
  returnTailwindColors,
  returnTailwindFonts,
  shopstoryProductFetch,
  contentfulAssets,
} = require('./utils');

const shopstoryConfig = {
  plugins: [
    contentfulPlugin({
      space: process.env.GATSBY_CONTENTFULL_SPACE_ID,
      environment: process.env.GATSBY_CONTENTFULL_ENVIRONMENT,
      accessToken: process.env.GATSBY_CONTENTFULL_TOKEN,
      previewAccessToken: process.env.GATSBY_CONTENTFULL_PREVIEW_TOKEN,
    }),
  ],
  resourceTypes: {
    asset: {
      fetch: contentfulAssets.fetch,
      widget: {
        type: 'item-picker',
        getItems: contentfulAssets.getItems,
        getItemById: contentfulAssets.getItemById,
      },
    },
    path: {
      fetch: async (resources, params) =>
        fetchContentfulEntry(resources, 'path', params),
      widget: {
        type: 'item-picker',
        getItems: async (query) => getContentfulItems(query, 'path'),
        getItemById: async (id) => getContentfulItemById(id),
      },
    },
    color: {
      fetch: async (resources, params) =>
        fetchContentfulEntry(resources, 'color', params),
      widget: {
        type: 'item-picker',
        getItems: async (query) => getContentfulItems(query, 'color'),
        getItemById: async (id) => getContentfulItemById(id),
      },
    },

    label: {
      fetch: async (resources, params) =>
        fetchContentfulEntry(resources, 'label', params, 3),
      widget: {
        type: 'item-picker',
        getItems: async (query) => getContentfulItems(query, 'label'),
        getItemById: async (id) => getContentfulItemById(id),
      },
    },
    paragraph: {
      fetch: async (resources, params) =>
        fetchContentfulEntry(resources, 'paragraph', params),
      widget: {
        type: 'item-picker',
        getItems: async (query) => getContentfulItems(query, 'paragraph'),
        getItemById: async (id) => getContentfulItemById(id),
      },
    },
    icon: {
      fetch: async (resources, params) =>
        fetchContentfulEntry(resources, 'icon', params, 2),
      widget: {
        type: 'item-picker',
        getItems: async (query) => getContentfulItems(query, 'icon'),
        getItemById: async (id) => getContentfulItemById(id),
      },
    },
    product: {
      fetch: async (resources, params) =>
        shopstoryProductFetch(resources, 'product', params),
      widget: {
        type: 'item-picker',
        getItems: async (query) => getContentfulItems(query, 'product'),
        getItemById: async (id) => getContentfulItemById(id),
      },
    },
    productVariant: {
      fetch: async (resources, params) =>
        fetchContentfulEntry(resources, 'productVariant', params),
      widget: {
        type: 'item-picker',
        getItems: async (query) => getContentfulItems(query, 'productVariant'),
        getItemById: async (id) => getContentfulItemById(id),
      },
    },
  },
  actions: [
    {
      id: 'SimpleDrawer',
      label: 'SimpleDrawer (Img + Label)',
      schema: [
        {
          prop: 'title',
          label: 'Title',
          type: 'resource',
          resourceType: 'label',
        },
        {
          prop: 'image',
          label: 'Image',
          type: 'resource',
          resourceType: 'asset',
        },
        {
          prop: 'body',
          label: 'Body',
          type: 'resource',
          resourceType: 'paragraph',
        },
      ],
    },
    {
      id: 'SlugLink',
      label: 'Link with Slug',
      schema: [
        {
          prop: 'slug',
          label: 'Slug',
          type: 'resource',
          resourceType: 'path',
        },
      ],
    },
  ],
  components: [
    {
      id: 'div',
      label: 'Div',
      type: 'card',
      schema: [
        {
          prop: 'flexDirection',
          label: 'Flex Direction',
          type: 'select',
          options: ['column', 'row'],
          defaultValue: 'row',
        },
      ],
    },
    {
      id: 'button',
      label: 'Default Button',
      type: 'item',
      schema: [
        {
          prop: 'label',
          label: 'Label',
          type: 'resource',
          resourceType: 'label',
        },
        {
          prop: 'slug',
          label: 'Slug',
          type: 'resource',
          resourceType: 'path',
        },
        {
          prop: 'color',
          label: 'Color',
          type: 'resource',
          resourceType: 'color',
        },
        {
          prop: 'type',
          label: 'Type',
          type: 'select',
          options: ['contained', 'outlined', 'white', 'circular'],
          defaultValue: 'contained',
        },
        {
          prop: 'size',
          label: 'Size',
          type: 'select',
          options: ['xs', 'sm', 'base', 'lg'],
          defaultValue: 'base',
        },
        {
          prop: 'fullWidth',
          label: 'Full Width',
          type: 'boolean',
        },
      ],
    },
    {
      id: 'label',
      label: 'Label',
      type: 'item',
      schema: [
        {
          prop: 'text',
          label: 'Text',
          type: 'string',
          defaultValue: 'Lorem Ipsun',
        },
        {
          prop: 'align',
          label: 'Align',
          type: 'select',
          options: ['text-left', 'text-center', 'text-right'],
        },
        {
          prop: 'color',
          label: 'Color',
          type: 'resource',
          resourceType: 'color',
        },
        {
          prop: 'size',
          label: 'Size',
          type: 'select',
          options: [
            'inherit',
            'xs',
            'sm',
            'base',
            'lg',
            'xl',
            '2xl',
            '3xl',
            '4xl',
            '5xl',
            '6xl',
            '7xl',
            '8xl',
          ],
        },
        {
          prop: 'decoration',
          label: 'Decoration',
          type: 'select',
          options: ['text-underline'],
        },
        {
          prop: 'family',
          label: 'Family',
          type: 'select',
          options: ['font-inter', 'font-gilmer'],
        },
        {
          prop: 'weight',
          label: 'Weight',
          type: 'select',
          options: ['light', 'normal', 'heavy'],
        },
      ],
    },
    {
      id: 'link',
      label: 'Link',
      type: 'item',
      schema: [
        {
          prop: 'label',
          label: 'Label',
          type: 'resource',
          resourceType: 'label',
        },
        {
          prop: 'slug',
          label: 'Slug',
          type: 'resource',
          resourceType: 'path',
          defaultValue: 'cat',
        },
        {
          prop: 'obfuscate',
          label: 'Is obfuscated',
          type: 'boolean',
          defaultValue: false,
        },
      ],
    },
    {
      id: 'badge',
      label: 'Badge',
      type: 'item',
      schema: [
        {
          prop: 'label',
          label: 'Label',
          type: 'resource',
          resourceType: 'label',
        },
        {
          prop: 'color',
          label: 'Color',
          type: 'resource',
          resourceType: 'color',
          defaultValue: 'cat',
        },
        {
          prop: 'dotColor',
          label: 'Dot Color',
          type: 'resource',
          resourceType: 'color',
          defaultValue: 'cat',
        },
        {
          prop: 'type',
          label: 'Type',
          type: 'select',
          options: ['contained', 'outlined', 'white'],
          defaultValue: 'contained',
        },
        {
          prop: 'size',
          label: 'Size',
          type: 'select',
          options: ['xs', 'sm', 'base', 'lg'],
          defaultValue: 'base',
        },
        {
          prop: 'dotPosition',
          label: 'Dot Position',
          type: 'select',
          options: ['left', 'right'],
          defaultValue: 'left',
        },
      ],
    },
    {
      id: 'badgeIcon',
      label: 'Badge Icon',
      type: 'item',
      schema: [
        {
          prop: 'label',
          label: 'Label',
          type: 'resource',
          resourceType: 'label',
        },
        {
          prop: 'color',
          label: 'Color',
          type: 'resource',
          resourceType: 'color',
          defaultValue: 'cat',
        },
        {
          prop: 'type',
          label: 'Type',
          type: 'select',
          options: ['contained', 'outlined', 'white'],
          defaultValue: 'contained',
        },
        {
          prop: 'size',
          label: 'Size',
          type: 'select',
          options: ['xs', 'sm', 'base', 'lg'],
          defaultValue: 'base',
        },
        {
          prop: 'icon',
          label: 'Icon',
          type: 'resource',
          resourceType: 'icon',
        },
        {
          prop: 'justifyContent',
          label: 'Align',
          type: 'select',
          options: ['flex-start', 'center', 'flex-end'],
          defaultValue: 'flex-start',
        },
      ],
    },
    {
      id: 'shopItem',
      label: 'Shop Item',
      type: 'card',
      schema: [
        {
          prop: 'product',
          label: 'Product',
          type: 'resource',
          resourceType: 'product',
        },
        {
          prop: 'detaultProductVariantIndex',
          label: 'Default Product Variant Index',
          type: 'number',
          default: 0,
        },
        {
          prop: 'label',
          label: 'Label',
          type: 'resource',
          resourceType: 'label',
        },
        {
          prop: 'subLabel',
          label: 'Sub Label',
          type: 'resource',
          resourceType: 'label',
          defaultValue: { text: 'Hello' },
        },
        {
          prop: 'hasQuickBuy',
          label: 'Has quick buy',
          type: 'boolean',
        },
        {
          prop: 'hasCategoryBadge',
          label: 'Has Categroy badge',
          type: 'boolean',
          defaultValue: true,
        },
        {
          prop: 'showColorPicker',
          label: 'Show Color Picker',
          type: 'boolean',
          defaultValue: true,
        },
        {
          prop: 'showButton',
          label: 'Show Button',
          type: 'boolean',
          defaultValue: true,
        },
      ],
    },
  ],
  devices: {
    xs: {
      w: 428, // Let's modify xs width and height to iPhone 13 Pro Max
      h: 926,
    },
    lg: {
      hidden: false, // Let's not hide horizontal tablets
    },
    xl: {
      startsFrom: 1200, // Let's move breakpoint of xl range to 1200
    },
  },
  colors: returnTailwindColors(),
  fonts: returnTailwindFonts(),
  space: [
    {
      id: 'containerMargin.default',
      value: '5vw',
    },
    {
      id: 'containerMargin.another',
      value: {
        '@xs': 16,
        '@md': 32,
        '@lg': 64,
      },
    },
  ],
  containerWidths: [
    {
      id: 'small',
      value: 800,
    },
    {
      id: 'large',
      value: 1200,
    },
  ],
};

module.exports = shopstoryConfig;
